/**
################################
 * Component geeg_sticky_footer
 * Built with Maciste / Version 2.0
################################
*/


'use strict';

jQuery(document).ready(function ($) {
    var $document = $(document),
        $element = $('#geeg_sticky_footer')


    $document.scroll(function() {
        if ($document.scrollTop() >= 250) {
            // user scrolled 50 pixels or more;
            // do stuff
            $element.addClass('geeg_sticky_footer--visible');
            $element.removeClass('geeg_sticky_footer--hidden');

        } else {
            $element.removeClass('geeg_sticky_footer--visible');
            $element.addClass('geeg_sticky_footer--hidden');

        }
    });
});

